var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0a2a0c3629"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6 3 L 372 3 L 372 369 L 6 369 Z M 6 3 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a5011d483b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 188.875 36.378906 C 106.242188 36.378906 39.25 103.367188 39.25 186.003906 C 39.25 268.640625 106.242188 335.628906 188.875 335.628906 C 271.511719 335.628906 338.5 268.640625 338.5 186.003906 C 338.5 103.367188 271.511719 36.378906 188.875 36.378906 Z M 6 186.003906 C 6 85.003906 87.875 3.128906 188.875 3.128906 C 289.875 3.128906 371.75 85.003906 371.75 186.003906 C 371.75 287.003906 289.875 368.878906 188.875 368.878906 C 87.875 368.878906 6 287.003906 6 186.003906 Z M 292.070312 116.0625 C 298.5625 122.554688 298.5625 133.082031 292.070312 139.574219 L 175.695312 255.949219 C 169.203125 262.441406 158.675781 262.441406 152.183594 255.949219 L 85.683594 189.449219 C 79.191406 182.957031 79.191406 172.429688 85.683594 165.9375 C 92.175781 159.445312 102.703125 159.445312 109.195312 165.9375 L 163.9375 220.679688 L 268.558594 116.0625 C 275.050781 109.570312 285.578125 109.570312 292.070312 116.0625 Z M 292.070312 116.0625 ",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0a2a0c3629)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a5011d483b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "M 6 3.128906 L 6 368.878906 L 371.75 368.878906 L 371.75 3.128906 Z M 6 3.128906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkGrey);
export default __webpack_public_path__ + "static/media/checkmark-grey.9a7564816247467077198b4e7e2e4d25.svg";
export { ForwardRef as ReactComponent };